import {sx} from './sx'

import {Stack} from "@mui/material";
import Navigate from "@view/navigate/Navigate";
import {useAccountStyle} from "@containers/accountStyle/hooks/useAccountStyle";

const Sidebar = () => {

    const {tokens} = useAccountStyle()

    return (
        <Stack
            sx={{...sx.root, background: tokens.panelBackground}}
            gap={1}
        >
            <Navigate/>
        </Stack>
    );
};

export default Sidebar;
